module.exports = __webpack_public_path__ + "media/theme/step--1_03-6b686d5b.png";